import { __decorate, __param } from 'tslib';
import { InjectionToken, Optional, Inject, Injectable, NgModule, APP_INITIALIZER } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { config as config$1, API_CONFIG } from '@ff/api';
import { BehaviorSubject } from 'rxjs';
import { AuthModule } from '@ff/auth';
import { UserModule, UserService } from '@ff/user';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common/http';
const OAUTH2_CONFIG = new InjectionToken('oauth2.config');

const config = {
    endpoints: {
        providers: '/oauth2/providers',
        bearer: '/oauth2/bearer'
    }
};

let OAuth2Service = class OAuth2Service {
    constructor(_apiConfig, _config, _httpClient) {
        this._apiConfig = _apiConfig;
        this._config = _config;
        this._httpClient = _httpClient;
        this._config = Object.assign(config, this._config);
        this._apiConfig = Object.assign(config$1, this._apiConfig);
        this._providers = new BehaviorSubject([]);
    }
    login(url) {
        return this._httpClient.get(url)
            .pipe(map((response) => response.data))
            .toPromise().then((response) => {
            sessionStorage.setItem('oauth2.state', response.state);
            window.location.href = response.url;
        });
    }
    fetchBearer() {
        return this._httpClient.get(this._apiConfig.host + this._config.endpoints.bearer + '/' + this.getState())
            .toPromise()
            .then((response) => response.data._token)
            .catch((e) => { });
    }
    fetchToken(id) {
        return this._httpClient.get(this._apiConfig.host + this._config.endpoints.bearer + '/' + id)
            .toPromise()
            .then((response) => response.data._token)
            .catch((e) => { });
    }
    fetchProviders() {
        return this._httpClient.get(this._apiConfig.host + this._config.endpoints.providers)
            .toPromise()
            .then((response) => {
            this._providers.next(response.data);
        })
            .catch(() => {
        });
    }
    getState() {
        return sessionStorage.getItem('oauth2.state');
    }
    clearState() {
        sessionStorage.removeItem('oauth2.state');
    }
    getProviders() {
        return this._providers;
    }
};
OAuth2Service.ɵfac = function OAuth2Service_Factory(t) { return new (t || OAuth2Service)(ɵngcc0.ɵɵinject(API_CONFIG, 8), ɵngcc0.ɵɵinject(OAUTH2_CONFIG, 8), ɵngcc0.ɵɵinject(ɵngcc1.HttpClient)); };
OAuth2Service.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: OAuth2Service, factory: function (t) { return OAuth2Service.ɵfac(t); } });
OAuth2Service.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [API_CONFIG,] }] },
    { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [OAUTH2_CONFIG,] }] },
    { type: HttpClient }
];
OAuth2Service = __decorate([ __param(0, Optional()), __param(0, Inject(API_CONFIG)),
    __param(1, Optional()), __param(1, Inject(OAUTH2_CONFIG))
], OAuth2Service);

function fetchBearer(oauth2service, userService) {
    return () => {
        let promise = null;
        oauth2service.fetchProviders();
        const url = new URL(window.location.href);
        const id = url.searchParams.get('_et');
        if (id) {
            promise = oauth2service.fetchToken(id).then((token) => {
                localStorage.setItem('_token', token);
                return userService.fetch();
            });
        }
        oauth2service.clearState();
        return promise;
    };
}

const ɵ0 = fetchBearer;
let OAuth2Module = class OAuth2Module {
};
OAuth2Module.ɵfac = function OAuth2Module_Factory(t) { return new (t || OAuth2Module)(); };
OAuth2Module.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: OAuth2Module });
OAuth2Module.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [
        OAuth2Service,
        {
            provide: APP_INITIALIZER,
            useFactory: ɵ0,
            multi: true,
            deps: [OAuth2Service, UserService]
        }
    ], imports: [[
            CommonModule,
            HttpClientModule,
            UserModule,
            AuthModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OAuth2Service, [{
        type: Injectable
    }], function () { return [{ type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [API_CONFIG]
            }] }, { type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [OAUTH2_CONFIG]
            }] }, { type: ɵngcc1.HttpClient }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OAuth2Module, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    HttpClientModule,
                    UserModule,
                    AuthModule
                ],
                providers: [
                    OAuth2Service,
                    {
                        provide: APP_INITIALIZER,
                        useFactory: ɵ0,
                        multi: true,
                        deps: [OAuth2Service, UserService]
                    }
                ],
                exports: []
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(OAuth2Module, { imports: function () { return [CommonModule,
        HttpClientModule,
        UserModule,
        AuthModule]; } }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { OAUTH2_CONFIG, OAuth2Module, OAuth2Service, fetchBearer as ɵa };

